import Layout from '../components/Layout';
import { useLanguage } from '../context/LanguageContext';

export function ConnectionsPage() {
    const { t } = useLanguage();
    return (
        <Layout>
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4 md:p-6">
                <h1 className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white mb-2">{t('connections')}</h1>
                <p className="text-gray-600 dark:text-gray-400 text-sm max-w-xl">{t('connectionsHint')}</p>
            </div>
        </Layout>
    );
}
